// pages/ForgotPassword.jsx
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import PhoneEmailVerify from '../components/PhoneEmailVerify';

import { API_BASE } from '../config';

function ForgotPassword() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [verificationUrl, setVerificationUrl] = useState(null);
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleVerified = ({ user_json_url }) => {
    setVerificationUrl(user_json_url);
    setError('');
    setStep(2);
  };

  const handleResetSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (newPassword.length < 6) return setError('Password must be at least 6 characters.');
    if (newPassword !== confirmPassword) return setError('Passwords do not match.');

    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_json_url: verificationUrl, newPassword }),
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.message || 'Password reset failed.');
        setLoading(false);
        return;
      }
      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify({ name: data.name, email: data.email, isAdmin: data.isAdmin }));
      navigate(data.isAdmin ? '/admin' : '/');
    } catch (err) {
      setError('Server error. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div className="page-narrow panel">
      <h2 className="display" style={{ fontSize: '22px', marginTop: 0 }}>Reset Password</h2>
      {error && <p style={{ color: '#ff4757', fontSize: '13px' }}>{error}</p>}

      {step === 1 && (
        <>
          <p className="muted" style={{ fontSize: '14px', marginBottom: '16px' }}>
            First, verify the email address on your account.
          </p>
          <PhoneEmailVerify rawMode onVerified={handleVerified} onError={setError} />
        </>
      )}

      {step === 2 && (
        <>
          <p style={{ color: '#3ea567', fontSize: '14px', marginBottom: '16px' }}>
            Email verified. Set your new password below.
          </p>
          <form onSubmit={handleResetSubmit}>
            <label className="field-label">New Password</label>
            <input type="password" className="input" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required minLength={6} style={{ marginBottom: '12px' }} />

            <label className="field-label">Confirm New Password</label>
            <input type="password" className="input" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required minLength={6} style={{ marginBottom: '16px' }} />

            <button type="submit" disabled={loading} className="btn-primary" style={{ width: '100%' }}>
              {loading ? 'Resetting...' : 'Reset Password & Log In'}
            </button>
          </form>
        </>
      )}

      <p style={{ marginTop: '18px', textAlign: 'center', fontSize: '14px' }}>
        <Link to="/login">Back to login</Link>
      </p>
    </div>
  );
}

export default ForgotPassword;
